export const invoiceDeliveryTypes = (state) => state.getIn(['invoiceDeliveryTypes', 'entities']);
export const invoiceDeliveryTypeById = (state, id) => invoiceDeliveryTypes(state).get(String(id));
export const invoiceDeliveryTypesByIds = (state, ids) => ids
  .map((id) => invoiceDeliveryTypeById(state, id));
